import React from 'react';

// Fahrzeug-Generationen. Bewusst als Konstante in der Komponente und nicht in
// Firestore: Diese Liste ändert sich alle paar Jahre, nicht alle paar Wochen.
const GENERATIONS = [
  {
    era: '1959 - 2000',
    name: 'Classic Mini',
    text: 'Das Original von Alec Issigonis. Quer eingebauter Motor, Räder in den Ecken, kaum größer als ein Sofa - und bis heute der Maßstab für Raumausnutzung.',
  },
  {
    era: '2001 - 2006',
    name: 'R50 / R53',
    text: 'Der Neuanfang unter BMW. Kompakt, direkt, mit dem legendären Kompressor im Cooper S. Für viele der Wagen, der sie zur Marke gebracht hat.',
  },
  {
    era: '2006 - 2013',
    name: 'R56 & Familie',
    text: 'Erwachsener, vielfältiger: Clubman, Cabrio, Countryman. Die Generation, die am häufigsten in unseren Reihen steht.',
  },
  {
    era: '2014 - heute',
    name: 'F56 und danach',
    text: 'Größer, komfortabler, technisch aufwendiger - und immer noch das Auto, das aus jeder Landstraße eine Kurvenstrecke macht.',
  },
];

export default function Cars() {
  return (
    <section className="mt-section" id="die-autos">
      <div className="mt-container">
        <div className="mt-head">
          <span className="mt-kicker">Die Autos</span>
          <h2>Vier Generationen, ein Grinsen</h2>
          <p>
            Bei uns steht der Classic neben dem aktuellen Cooper S - und beide haben denselben
            Grund, warum ihre Besitzer sie fahren. Ein kurzer Überblick, was du auf unseren
            Treffen so antriffst.
          </p>
        </div>

        <div className="mt-grid mt-grid--2">
          {GENERATIONS.map((gen) => (
            <article key={gen.name} className="mt-card mt-gen">
              <span className="mt-gen__era">{gen.era}</span>
              <h3>{gen.name}</h3>
              <p>{gen.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
